import React, { useState, useEffect, useRef } from 'react';
// import { IoIosArrowDown } from 'react-icons/io';
import useLayersStore from '../../stores/layersStore';
import InfoIcon from '../icons/InfoIcon';
import Button from '../../button';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

const ContentButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { annotations, expandedAnnotations, setExpandedAnnotation } = useLayersStore();
    const buttonRef = useRef(null);

    const toggleDropdown = (event) => {
        setIsOpen(!isOpen);
    };

    // Handle clicks outside the dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const featureEnabled = useLayersStore((state) => state.featureEnabled);
    if (featureEnabled.tableOfContent) {
        return (
            <div className='z-50 pointer-events-auto cursor-pointer relative overflow-visible w-[110px] sm:w-[180px]' ref={buttonRef}>
                <Button className='flex flex-col w-full'>
                    <div className='flex gap-1 items-center' onClick={toggleDropdown}>
                        <InfoIcon />
                        <div className='hidden sm:block'>Table of Contents</div>
                        <div className="sm:hidden">Contents</div>
                    </div>
                <div 
                    className={`overflow-hidden transition-all duration-300 w-full ${isOpen ? 'max-h-60' : 'max-h-0'}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <PerfectScrollbar
                        options={{
                            suppressScrollX: true,
                            minScrollbarLength: 20
                        }}
                        style={{
                            maxHeight: '240px',
                            width: '100%'
                        }}
                    >
                        <div className="py-1">
                            {annotations.map((item, index) => (
                                <div
                                    key={index}
                                    className='py-2 border-t border-gray-200 w-full text-start hover:bg-gray-100 transition-colors duration-150'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        // handleAnimationSelect(item);
                                        setExpandedAnnotation(item.id, !expandedAnnotations.has(item.id));
                                    }}
                                >
                                    {item.title}
                                </div>
                            ))}
                        </div>
                    </PerfectScrollbar>
                </div>
            </Button>
        </div>
    );
    }
    return <div className='w-[180px]'/>;
};

export default ContentButton; 
